import { useQuery } from "react-query";
import getMergeDetails from "./getMergeDetails";
var useGetMergeDetails = function useGetMergeDetails(patientUid, enabled, options) {
  var _options$alwaysFresh;
  var alwaysFresh = (_options$alwaysFresh = options === null || options === void 0 ? void 0 : options.alwaysFresh) !== null && _options$alwaysFresh !== void 0 ? _options$alwaysFresh : false;
  return useQuery(["merge-details", patientUid], function () {
    return getMergeDetails(patientUid);
  }, {
    enabled: enabled && !!patientUid,
    staleTime: alwaysFresh ? 0 : 5 * 60 * 1000,
    refetchOnMount: alwaysFresh ? "always" : false,
    refetchOnWindowFocus: false
  });
};
export default useGetMergeDetails;